import { render, staticRenderFns } from "./FileToUpload.vue?vue&type=template&id=489e654a&scoped=true"
import script from "./FileToUpload.vue?vue&type=script&lang=js"
export * from "./FileToUpload.vue?vue&type=script&lang=js"
import style0 from "./FileToUpload.vue?vue&type=style&index=0&id=489e654a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e654a",
  null
  
)

export default component.exports